'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThumbUp, iconThumbUpTag } from '@ni/nimble-components/dist/esm/icons/thumb-up';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThumbUp };
export { iconThumbUpTag };
export const NimbleIconThumbUp = wrap(IconThumbUp);